import React from 'react';
import { DEFAULTS } from './InfoIcon.types';
import { Typography } from '../../../electrons';
import { Tooltip } from '../../Tooltip';
import { Icon } from '../index';
export function InfoIcon(props) {
    const { id, className, fontSize, message } = props;
    const color = props.color || DEFAULTS.color;
    const iconType = props.iconType || DEFAULTS.iconType;
    const position = props.position || DEFAULTS.position;
    const tooltipContent = React.createElement(Typography, { variant: "body2" }, message);
    return (React.createElement(Tooltip, { id: id, className: className, title: tooltipContent, role: "tooltip", placement: position },
        React.createElement(Icon, { id: id, color: color, fontSize: fontSize }, iconType)));
}
//# sourceMappingURL=InfoIcon.js.map